import { useAppSelector } from "../../../../app/hooks";
import { isHigherThanDistrictAdmin, UserRole } from "../../../../app/userSlice";
import { EditUserViewModel } from "../../usersApiSlice";
import UserActiveSetting from "./UserActiveSetting";
import UserAvatarSetting from "./UserAvatarSetting";
import ResetPasswordSetting from "./ResetPasswordSetting";
import ResendWelcomeEmail from "./ResendWelcomeEmail";

interface Props {
	userInfo: EditUserViewModel;
	setSuccessMessage: (message: string) => void;
	setErrorMessage: (message: string) => void;
}

export default function UserAccountSettingsSection(props: Props) {
	const { config } = useAppSelector((state) => state.site);

	const gridClass = props.userInfo.showWelcomeEmailResend
		? `grid-cols-[repeat(auto-fit,minmax(250px,1fr))] ${props.userInfo.userImageDisabledBy ? "xl:grid-cols-2" : "xl:grid-cols-4"}`
		: config?.isUtahComposeSite && isHigherThanDistrictAdmin(props.userInfo.role)
			? "grid-cols-[repeat(auto-fit,minmax(175px,1fr))]"
			: `xl:grid-cols-[repeat(auto-fit,minmax(240px,1fr))] ${
					props.userInfo.userImageDisabledBy
						? "grid-cols-[repeat(auto-fit,minmax(250px,1fr))]"
						: "grid-cols-[repeat(auto-fit,minmax(200px,1fr))]"
				}`;

	return (
		<section
			className={`${props.userInfo.showWelcomeEmailResend ? "" : "xl:w-auto"} pr-4 self-start w-full`}>
			<div className="flex items-center px-5 py-4 h-[70px]">
				<p className="text-xl font-medium text-gray-900">User Settings</p>
			</div>
			<div className={`${gridClass} grid gap-6 mb-4 px-4 w-full`}>
				<UserActiveSetting
					userInfo={props.userInfo}
					setErrorMessage={props.setErrorMessage}
				/>
				{!config?.isUtahComposeSite && (
					<UserAvatarSetting
						userInfo={props.userInfo}
						setErrorMessage={props.setErrorMessage}
					/>
				)}
				{!isHigherThanDistrictAdmin(props.userInfo.role) && (
					<ResetPasswordSetting
						userInfo={props.userInfo}
						setSuccessMessage={props.setSuccessMessage}
						setErrorMessage={props.setErrorMessage}
					/>
				)}
				{props.userInfo.showWelcomeEmailResend && (
					<ResendWelcomeEmail
						userInfo={props.userInfo}
						setSuccessMessage={props.setSuccessMessage}
						setErrorMessage={props.setErrorMessage}
					/>
				)}
			</div>
		</section>
	);
}
